import LanguageContainer from "./LanguageContainer";
import { LanguageInterface } from "./LanguageInterface";
import * as React from "react";
import Logger from "../Logger/Logger";

class Translator {
  protected prefix: string = "[MISSING]";
  protected language: LanguageInterface;
  public loggedErrorFields: string[] = [];

  constructor() {
    this.language = LanguageContainer.resolve("nl-NL");
  }

  public use(iso: string): void {
    this.language = LanguageContainer.resolve(iso);
  }

  public getListOfMissingKeys() {
    return this.loggedErrorFields;
  }

  public trans(key: string, params: any = {}, locale: string = "", sendToLogger: boolean = true): string {
    let language = this.language;

    key = !!key && key.toLowerCase()
    if (locale.length > 0) {
      language = LanguageContainer.resolve(locale);
    }

    let value = language.get(key);

    // If we don't have a translation for this key, we can simply return the key as is.
    if (typeof value === "undefined") {
      if (!this.loggedErrorFields.includes(key) && sendToLogger) {
        this.loggedErrorFields.push(key);
        Logger.logError(new Error(`Translation needed: ${this.prefix} ${key}`), "warning");
      }

        return `${this.prefix} ${key}`;
    }

    // Replace each :attr with the attribute value.
    Object.keys(params || {}).forEach(binding => {
      value = value.split(`:${binding}`).join(params[binding]);
    });

    return value;
  }

  public transJSX(key: string, params: any = {}, locale: string = "", sendToLogger: boolean = true): JSX.Element {
    let language = this.language;
    key = !!key && key.toLowerCase()
    if (locale.length > 0) {
      language = LanguageContainer.resolve(locale);
    }

    let value: any = language.get(key);

    // If we don't have a translation for this key, we can simply return the key as is.
    if (typeof value === "undefined") {
      if (!key) {
        value = `${this.trans("default-error-message")}`;
      }
      
      if (key) {
        value = `${this.prefix} ${key}`;
      }

      if (!this.loggedErrorFields.includes(key) && sendToLogger) {
        this.loggedErrorFields.push(key);
        Logger.logError(new Error(`Translation needed: ${this.prefix} ${key}`), "warning");
      }

      return (<div>{value}</div>);
    }

    let valueArr = value.split(` `);

    Object.keys(params || {}).forEach(binding => {
      valueArr.forEach((item, index) => {
        if (item === `:${binding}`) {
          return valueArr[index] = params[binding];
        }

        if (typeof item === "string" &&
          item.indexOf(`:${binding}`) !== -1 && item.length > `:${binding}`.length) {
          valueArr[index] = params[binding];
          return valueArr.splice(index + 1, 0, item.slice(`:${binding}`.length - item.length));
        }
      })
    });

    let finalArr = [];
    let stringsArr = [];

    for (let i = 0; i < valueArr.length; i++) {
      if (typeof valueArr[i] === "string" || typeof valueArr[i] === "number") {
        if (i < valueArr.length - 1 && typeof valueArr[i + 1] === "string" &&
          (valueArr[i + 1].indexOf(".") === 0 ||
            valueArr[i + 1].indexOf(",") === 0 ||
            valueArr[i + 1].indexOf("-") === 0 ||
            valueArr[i + 1].indexOf(":") === 0 ||
            valueArr[i + 1].indexOf(";") === 0)
        ) {
          valueArr[i] = valueArr[i] + valueArr[i + 1];
          valueArr.splice(i + 1, 1);
        }

        stringsArr = [...stringsArr, valueArr[i]];

        if (i === valueArr.length - 1) {
          finalArr = [...finalArr, [...stringsArr].join(" ")];
        }
      } else {
        finalArr = [...finalArr, [...stringsArr].join(" ")];
        finalArr = [...finalArr, " "];
        finalArr = [...finalArr, valueArr[i]];
        finalArr = [...finalArr, " "];
        stringsArr = [];
      }
    }

    finalArr.forEach((item, index) => {
      if (item === " " && index < finalArr.length - 1 && typeof finalArr[index + 1] === "string" &&
        (finalArr[index + 1].indexOf(".") === 0 ||
          finalArr[index + 1].indexOf(",") === 0 ||
          finalArr[index + 1].indexOf("-") === 0 ||
          finalArr[index + 1].indexOf(":") === 0 ||
          finalArr[index + 1].indexOf(";") === 0)
      ) {
        finalArr.splice(index, 1);
      }
    });

    return (<div>{finalArr}</div>);
  }

  public empty(): string {
    return "";
  }
}

export default new Translator();
